import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../styles/Login.css';

const Register = () => {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [repeatPassword, setRepeatPassword] = useState('');
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isRepeatPasswordVisible, setIsRepeatPasswordVisible] = useState(false);
  const [agreedTerms, setAgreedTerms] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (password !== repeatPassword) {
      setError('Mật khẩu nhập lại không khớp.');
      return;
    }
    if (password.length < 8) {
      setError('Mật khẩu phải có ít nhất 8 ký tự.');
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/client/auth/otp/send`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'accept': 'application/json' },
        body: JSON.stringify({ full_name: fullName, email, phone, password })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Gửi mã OTP thất bại. Vui lòng thử lại.');
      }

      setSuccess('Mã OTP đã được gửi! Đang chuyển đến trang xác thực...');
      setTimeout(() => navigate('/verify-otp', { state: { email, fullName, phone, password } }), 1000);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const inputClass = "w-full pl-12 pr-4 py-4 bg-hp-surface-container-low border-none rounded-xl focus:ring-2 focus:ring-hupath-scout/30 transition-all font-body text-hp-on-surface placeholder:text-hp-outline";
  const inputClassPassword = "w-full pl-12 pr-12 py-4 bg-hp-surface-container-low border-none rounded-xl focus:ring-2 focus:ring-hupath-scout/30 transition-all font-body text-hp-on-surface placeholder:text-hp-outline";

  return (
    <div className="min-h-screen flex items-stretch overflow-hidden bg-hp-surface font-body text-hp-on-surface">

      {/* ── LEFT HERO PANEL ── */}
      <section className="hidden lg:flex lg:w-3/5 hp-hero-gradient--register relative flex-col justify-between p-12 overflow-hidden">
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <div className="bg-white/90 backdrop-blur-md p-3 rounded-xl shadow-sm">
              <span className="material-symbols-outlined text-hupath-owl text-3xl" style={{ fontVariationSettings: "'FILL' 1" }}>park</span>
            </div>
            <h1 className="font-headline font-black text-3xl text-hupath-owl tracking-tight">HuPath</h1>
          </div>
        </div>

        <div className="relative z-10 max-w-2xl mb-12">
          <div className="inline-flex items-center gap-2 bg-white/30 backdrop-blur-xl px-4 py-2 rounded-full mb-6 text-hupath-owl font-headline font-bold text-sm">
            <span className="material-symbols-outlined text-sm">rocket_launch</span>
            Bắt đầu hành trình mới
          </div>
          <h2 className="font-headline text-5xl xl:text-6xl font-extrabold text-hupath-ink leading-[1.1] mb-6">
            Bắt đầu hành trình chinh phục Cambridge English! 🚀
          </h2>
          <p className="font-body text-xl text-hupath-ink/80 leading-relaxed max-w-lg italic">
            Tham gia cùng hàng nghìn học sinh đang khám phá con đường chinh phục tiếng Anh cùng HuPath.
          </p>
        </div>

        <div className="absolute inset-0 pointer-events-none">
          {/* Main Illustration Image */}
          <div className="absolute top-[15%] right-[5%] w-[60%] max-w-lg z-0">
            <div className="bg-white/80 rounded-xl p-6 shadow-xl shadow-hupath-gold/10 transform -rotate-2">
              <img
                alt="Kids adventure"
                className="rounded-lg w-full h-auto object-cover"
                src="https://lh3.googleusercontent.com/aida-public/AB6AXuB1JSOGyO1c-AOdv77PhJ0llZynigEB7WizLPShB9utG4tw7sdJ_gk98PU9Z3RvLQ2GNHfV0Dh9DLpF80GryG8F6izdnwo1LF-6z5PSXrizqWAMbPX64R6uLn_oukIfZ2XLVr-arbnnCnEC7u_05LP514DmPQk48H-D6Ny_U3ceCQ6z2ySLaLWDaFbZGR666WoIeoZG1bYCSFtsAgtKKEWT5oxEmI5ayvyoMd4o3UK54LXuEzKgpmAICgu4fcpI3Dt9MSojybt8tA"
              />
            </div>
          </div>
          {/* Floating Cloud Ornaments */}
          <div className="absolute top-1/4 right-1/4 w-48 h-24 bg-white/40 blur-2xl rounded-full opacity-60"></div>
          <div className="absolute bottom-1/3 left-1/4 w-64 h-32 bg-hupath-gold/30 blur-3xl rounded-full opacity-50"></div>
        </div>
      </section>

      {/* ── RIGHT FORM PANEL ── */}
      <main className="w-full lg:w-2/5 bg-white flex items-center justify-center p-6 md:p-12 relative overflow-y-auto">
        <div className="w-full max-w-md relative z-10">
          {/* Mobile Logo */}
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <span className="material-symbols-outlined text-hupath-scout text-2xl" style={{ fontVariationSettings: "'FILL' 1" }}>park</span>
            <span className="font-headline font-bold text-xl text-hupath-scout">HuPath</span>
          </div>

          <div className="mb-8">
            <h3 className="font-headline text-3xl font-bold text-hp-on-surface mb-3">Đăng ký tài khoản</h3>
            <p className="font-body text-base text-hp-on-surface-variant">
              Tạo tài khoản để bắt đầu luyện thi Cambridge English
            </p>
          </div>

          <form className="space-y-4" onSubmit={handleSubmit}>
            {/* Full Name */}
            <div className="space-y-2">
              <label className="text-sm font-medium font-headline text-hp-on-surface-variant ml-1" htmlFor="fullName">Họ và tên</label>
              <div className="relative flex items-center group">
                <span className="material-symbols-outlined absolute left-4 text-hp-outline group-focus-within:text-hupath-scout transition-colors">person</span>
                <input id="fullName" type="text" placeholder="Nhập họ và tên của bé" value={fullName}
                  onChange={(e) => setFullName(e.target.value)} required className={inputClass} />
              </div>
            </div>

            {/* Email */}
            <div className="space-y-2">
              <label className="text-sm font-medium font-headline text-hp-on-surface-variant ml-1" htmlFor="email">Email</label>
              <div className="relative flex items-center group">
                <span className="material-symbols-outlined absolute left-4 text-hp-outline group-focus-within:text-hupath-scout transition-colors">mail</span>
                <input id="email" type="email" placeholder="example@email.com" value={email}
                  onChange={(e) => setEmail(e.target.value)} required className={inputClass} />
              </div>
            </div>

            {/* Phone */}
            <div className="space-y-2">
              <label className="text-sm font-medium font-headline text-hp-on-surface-variant ml-1" htmlFor="phone">Số điện thoại</label>
              <div className="relative flex items-center group">
                <span className="material-symbols-outlined absolute left-4 text-hp-outline group-focus-within:text-hupath-scout transition-colors">phone</span>
                <input id="phone" type="tel" placeholder="090 123 4567" value={phone}
                  onChange={(e) => setPhone(e.target.value)} className={inputClass} />
              </div>
            </div>

            {/* Password */}
            <div className="space-y-2">
              <label className="text-sm font-medium font-headline text-hp-on-surface-variant ml-1" htmlFor="password">Mật khẩu</label>
              <div className="relative flex items-center group">
                <span className="material-symbols-outlined absolute left-4 text-hp-outline group-focus-within:text-hupath-scout transition-colors">lock</span>
                <input id="password" type={isPasswordVisible ? 'text' : 'password'} placeholder="Ít nhất 8 ký tự" value={password}
                  onChange={(e) => setPassword(e.target.value)} required className={inputClassPassword} />
                <button type="button" onClick={() => setIsPasswordVisible(!isPasswordVisible)}
                  className="absolute right-4 text-hp-outline hover:text-hupath-scout transition-colors" aria-label="Toggle password">
                  <span className="material-symbols-outlined">{isPasswordVisible ? 'visibility' : 'visibility_off'}</span>
                </button>
              </div>
            </div>

            {/* Confirm Password */}
            <div className="space-y-2">
              <label className="text-sm font-medium font-headline text-hp-on-surface-variant ml-1" htmlFor="repeatPassword">Xác nhận mật khẩu</label>
              <div className="relative flex items-center group">
                <span className="material-symbols-outlined absolute left-4 text-hp-outline group-focus-within:text-hupath-scout transition-colors">lock</span>
                <input id="repeatPassword" type={isRepeatPasswordVisible ? 'text' : 'password'} placeholder="Nhập lại mật khẩu" value={repeatPassword}
                  onChange={(e) => setRepeatPassword(e.target.value)} required className={inputClassPassword} />
                <button type="button" onClick={() => setIsRepeatPasswordVisible(!isRepeatPasswordVisible)}
                  className="absolute right-4 text-hp-outline hover:text-hupath-scout transition-colors" aria-label="Toggle repeat password">
                  <span className="material-symbols-outlined">{isRepeatPasswordVisible ? 'visibility' : 'visibility_off'}</span>
                </button>
              </div>
            </div>

            {/* Terms */}
            <div className="flex items-start gap-3 py-2">
              <input type="checkbox" id="terms" checked={agreedTerms} onChange={(e) => setAgreedTerms(e.target.checked)}
                className="mt-1 w-5 h-5 rounded text-hupath-scout focus:ring-hupath-scout border-hp-outline-variant bg-hp-surface-container-low" />
              <label className="text-sm text-hp-on-surface-variant font-body" htmlFor="terms">
                Tôi đồng ý với <a className="text-hupath-scout font-medium hover:underline" href="/#">Điều khoản sử dụng</a> và <a className="text-hupath-scout font-medium hover:underline" href="/#">Chính sách bảo mật</a>
              </label>
            </div>

            {/* Error / Success */}
            {error && (
              <div className="flex items-center gap-2 bg-red-50 border border-red-300 rounded-xl px-4 py-3 text-red-600 text-sm font-medium">
                <span className="material-symbols-outlined text-lg">error</span>{error}
              </div>
            )}
            {success && (
              <div className="flex items-center gap-2 bg-green-50 border border-green-300 rounded-xl px-4 py-3 text-green-600 text-sm font-medium">
                <span className="material-symbols-outlined text-lg">check_circle</span>{success}
              </div>
            )}

            {/* Submit */}
            <button type="submit" disabled={isLoading || !agreedTerms}
              className="w-full hp-button-gradient text-white font-headline font-bold text-lg py-4 rounded-xl shadow-[0px_8px_24px_rgba(42,107,48,0.25)] hover:scale-[1.02] active:scale-95 transition-all disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:scale-100">
              {isLoading ? (
                <><span className="material-symbols-outlined lf-spin text-xl">progress_activity</span> Đang đăng ký...</>
              ) : 'Đăng ký'}
            </button>
          </form>

          {/* Divider */}
          <div className="relative flex items-center gap-4 py-4">
            <div className="flex-grow h-px bg-hp-outline-variant/30"></div>
            <span className="text-sm font-label text-hp-outline uppercase tracking-widest">hoặc</span>
            <div className="flex-grow h-px bg-hp-outline-variant/30"></div>
          </div>

          {/* Google */}
          <button type="button"
            className="w-full py-4 bg-white border border-hp-outline-variant/30 text-hp-on-surface font-headline font-semibold rounded-xl flex items-center justify-center gap-3 hover:bg-hp-surface-container-low transition-colors shadow-sm">
            <svg className="w-5 h-5" viewBox="0 0 24 24"><path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4"/><path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/><path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/><path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/></svg>
            Đăng ký với Google
          </button>

          {/* Login Link */}
          <div className="mt-8 text-center">
            <p className="text-hp-on-surface-variant font-body">
              Đã có tài khoản?{' '}
              <Link to="/login" className="text-hupath-scout font-bold font-headline ml-1 hover:underline">Đăng nhập</Link>
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Register;
